import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { isInternalPagesHost } from '../utils/internalPages';

const DashboardLayout = () => {
  const [hoveredLink, setHoveredLink] = useState(null);
  const showInternalPages = isInternalPagesHost();

  const navLinks = [
    { to: '/', label: 'Home' },
    { to: '/about', label: 'About' },
    { to: '/resources', label: 'Resources' },
    { to: '/monitor', label: 'Monitor' },
    ...(showInternalPages
      ? [
          { to: '/mom', label: 'MOM' },
          { to: '/dataaaa-analysis', label: 'Dataaaa Analysis' },
          { to: '/b27-regime-adaptation', label: 'B27 Regime 80/20' },
          { to: '/b27-regime-rolling', label: 'B27 Regime 2mo+15d' },
        ]
      : []),
    { to: '/contact', label: 'Contact Us'}
  ];

  return (
    <div style={styles.header}>
      <Link to="/" style={styles.logoLink}>
        <img
          src="/brentspence.png"
          alt="Brent Spence Logo"
          style={{ height: '40px', width: 'auto' }}
        />
      </Link>

      <nav style={{ display: 'flex', gap: '1rem', position: 'relative' }}>
        {navLinks.map((link, index) => (
          <div
            key={index}
            style={{ position: 'relative' }}
            onMouseEnter={() => {
              setHoveredLink(index);
            }}
            onMouseLeave={() => {
              setHoveredLink(null);
            }}
          >
            <Link
              to={link.to}
              style={{
                ...linkStyle,
                color: hoveredLink === index ? '#FFD700' : 'white',
                display: 'flex',
                alignItems: 'center',
                gap: '4px',
                cursor: 'pointer'
              }}
            >
              {link.label}
            </Link>
          </div>
        ))}
      </nav>
    </div>
  );
};

const styles = {
  header: {   //So this is the header, thats the big dark blue box on the top that has all stuff about Home, ABout and the BSB Main ICON
    height: '60px',
    backgroundColor: '#353849',
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    padding: '0 2rem',
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    zIndex: 1000,
    boxShadow: '0 2px 5px rgba(0, 0, 0, 1)'
  },
  logoLink: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '2rem',
    textDecoration: 'none'
  },
};

const linkStyle = {
  textDecoration: 'none',
  fontSize: '1rem',
  transition: 'color 0.3s ease'
};

export default DashboardLayout;